/* eslint-disable */
import { ASSISTED_USERS_MYSELF } from '@ringcentral-integration/commons/modules/Meeting';
export default {
  date: 'Data',
  time: 'Ora',
  hours: '{howMany} h',
  minutes: '{howMany} min',
  today: 'Oggi',
  duration: 'Durata',
  topic: 'Titolo della riunione',
  voIPOnly: 'Solo audio di Internet',
  telephonyOnly: 'Solo telefono',
  both: 'Telefono e audio Internet',
  thirdParty: 'Audio di terze parti',
  meetingId: 'ID riunione',
  password: 'Password',
  video: 'Video',
  audio: 'Audio',
  scheduleFor: 'Programma per conto di',
  [ASSISTED_USERS_MYSELF]: 'Me',
  meetingOptions: 'Opzioni riunione',
  meetingSettings: 'Impostazioni riunione',
  rcMeetingSettings: 'Impostazioni riunioni video',
  audioOptions: 'Opzioni audio',
  recurringMeeting: 'Riunione ricorrente',
  recurringNote: 'Nota: Abilita questa opzione quando scegli "Ricorrenza"',
  joinBeforeHost: "Consenti ai partecipanti di accedere prima dell'host",
  turnOffCamera: 'Disattiva la videocamera per i partecipanti',
  turnOffHostCamera:
    "Disattiva la videocamera per l'host durante l'accesso alla riunione",
  requirePassword: 'Richiedi password',
  enterPassword: 'Immetti password',
  setPassword: 'Imposta password*',
  passwordEmptyError: 'La password per la riunione è obbligatoria',
  rcmPasswordInvalidError:
    'La password deve avere 1-10 caratteri, deve contenere numeri e non può contenere simboli, tranne @, * o -',
  rcmPasswordHintText:
    'La password deve avere 1-10 caratteri, deve contenere numeri e non può contenere simboli, tranne @, * o -',
  usePersonalMeetingId: 'Usa ID riunione personale',
  pmiChangeConfirm: 'Se vuoi apportare modifiche alla tua riunione personale, ',
  changePmiSettings: 'modifica le impostazioni del PMI',
  pmiSettingChangeAlert:
    'Se modifichi le impostazioni e programmi questa riunione, tutte le riunioni con ID riunione personale utilizzeranno le stesse impostazioni più recenti.',
  lockedTooltip: "L'impostazione è gestita dall'amministratore dell'azienda",
  when: 'Data/Ora',
  recurringDescribe:
    "Ricorda di verificare che l'invito sia ricorrente o ripetuto sul calendario dei partecipanti.",
} as const;

// @key: @#@"date"@#@ @source: @#@"Date"@#@
// @key: @#@"time"@#@ @source: @#@"Time"@#@
// @key: @#@"hours"@#@ @source: @#@"{howMany} hr"@#@
// @key: @#@"minutes"@#@ @source: @#@"{howMany} min"@#@
// @key: @#@"today"@#@ @source: @#@"Today"@#@
// @key: @#@"duration"@#@ @source: @#@"Duration"@#@
// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
// @key: @#@"voIPOnly"@#@ @source: @#@"Internet audio only"@#@
// @key: @#@"telephonyOnly"@#@ @source: @#@"Telephone only"@#@
// @key: @#@"both"@#@ @source: @#@"Telephone and Internet audio"@#@
// @key: @#@"thirdParty"@#@ @source: @#@"3rd party audio"@#@
// @key: @#@"meetingId"@#@ @source: @#@"Meeting ID"@#@
// @key: @#@"password"@#@ @source: @#@"Password"@#@
// @key: @#@"video"@#@ @source: @#@"Video"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"scheduleFor"@#@ @source: @#@"Schedule on behalf of"@#@
// @key: @#@"ASSISTED_USERS_MYSELF"@#@ @source: @#@"Myself"@#@
// @key: @#@"meetingOptions"@#@ @source: @#@"Meeting options"@#@
// @key: @#@"meetingSettings"@#@ @source: @#@"Meeting settings"@#@
// @key: @#@"rcMeetingSettings"@#@ @source: @#@"Video Meeting settings"@#@
// @key: @#@"audioOptions"@#@ @source: @#@"Audio options"@#@
// @key: @#@"recurringMeeting"@#@ @source: @#@"Recurring meeting"@#@
// @key: @#@"recurringNote"@#@ @source: @#@"Note: Enable this one when choosing \"Recurrence\""@#@
// @key: @#@"joinBeforeHost"@#@ @source: @#@"Allow participants to join before host"@#@
// @key: @#@"turnOffCamera"@#@ @source: @#@"Turn off camera for participants"@#@
// @key: @#@"turnOffHostCamera"@#@ @source: @#@"Turn off camera for host when joining meeting"@#@
// @key: @#@"requirePassword"@#@ @source: @#@"Require password"@#@
// @key: @#@"enterPassword"@#@ @source: @#@"Enter Password"@#@
// @key: @#@"setPassword"@#@ @source: @#@"Set password *"@#@
// @key: @#@"passwordEmptyError"@#@ @source: @#@"Meeting password required"@#@
// @key: @#@"rcmPasswordInvalidError"@#@ @source: @#@"Your password must be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"rcmPasswordHintText"@#@ @source: @#@"Your password should be 1-10 characters, numbers long and cannot have symbols except @, * or -"@#@
// @key: @#@"usePersonalMeetingId"@#@ @source: @#@"Use Personal Meeting ID"@#@
// @key: @#@"pmiChangeConfirm"@#@ @source: @#@"If you want to make changes for your Personal Meeting, "@#@
// @key: @#@"changePmiSettings"@#@ @source: @#@"change PMI settings"@#@
// @key: @#@"pmiSettingChangeAlert"@#@ @source: @#@"If you change the settings and schedule this meeting, all of meetings with Personal Meeting ID will use the same latest settings."@#@
// @key: @#@"lockedTooltip"@#@ @source: @#@"This setting is managed by your company admin"@#@
// @key: @#@"when"@#@ @source: @#@"When"@#@
// @key: @#@"recurringDescribe"@#@ @source: @#@"Please remember to check recurrence or repeat in your calendar invitation to your attendees."@#@
